import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import withAuth from "../../components/withAuth";
import qs from "querystringify";
import { v4 as uuidv4 } from "uuid"; // random
import moment from "moment";

// STATE AND STORE
// LIBS
import API from "../../api";
import Model from "../../models/reports";
import validateForm from "../../lib/helpers/validateForm";
import {
  fioLitleTruncateFromObject,
  sumFormat
} from "../../lib/helpers/strings";
import { getDateFormat, getTimeFormat } from "../../lib/helpers/dates";
import { getQueryParams } from "../../lib/helpers/bilets";
import {
  getStatusString,
  getStatusClassString
} from "../../lib/helpers/bilets";
import {
  getFilialSumsHistorys,
  getSumPercent,
  getGiveOnly,
  // getCloseOnly,
  getNewSumPercent,
  getFinesToHistory,
  getSumAll
} from "../../lib/helpers/history";

// UI
import {
  Alerts,
  Table,
  Input,
  Button,
  Row,
  Col,
  Header,
  HeaderPage,
  P,
  ButtonGroup,
  Modal,
  Section,
  VirtualDiv,
  Dropdown
} from "../../ui";
import IconEdit from "../../ui/src/ui/components/icons/edit";
import IconAddFilled from "../../ui/src/ui/components/icons/addFilled";
import IconMinusFilled from "../../ui/src/ui/components/icons/minusFilled";
import IconClockFilled from "../../ui/src/ui/components/icons/clockFilled";
import IconRefreshFilled from "../../ui/src/ui/components/icons/refreshFilled";

// CSS
import "../../css/reports.css";
import DaySumsAll from "./components/daySumsAll";
import DaySumsAllFilialTable from "./components/daySumsAllFilialTable";

const TITLE_HEADER = "Отчёт за день";

class ReportDayPage extends Component {
  state = {
    titleHeader: TITLE_HEADER,
    loading: true,
    reports: {
      list: [],
      meta: { date: getDateFormat(new Date()), saved: false }
    },
    filials: {
      list: []
    },
    sumAll: {
      cashDeskStart: 0,
      sumGive: 0,
      sumPercent: 0,
      sumFine: 0,
      sumIncome: 0,
      sumReturn: 0,
      sumIncomeWithReturn: 0,
      sumAdd: 0,
      sumRemove: 0,
      sumClose: 0,
      cashDesk: 0
    },
    search: false,
    form: {
      date: {
        value: "",
        isDate: "",
        isError: false,
        errors: [],
        validate: Model.date
      },
      filial: {
        value: "",
        isEdited: false,
        isError: false,
        errors: [],
        validate: Model.filial
      }
    },
    footers: {
      day: []
    },
    modals: {
      deleteReportDay: {
        title: "Удаление отчёта за день",
        yesTitle: "Удалить отчёт",
        yesClassName: "error",
        isShow: false,
        selectedItemId: null,
        yesDisabled: false
      }
    },
    buttons: {
      deleteDisabled: false,
      generateDisabled: false,
      generateVisible: false,
      filtersDisabled: false
    }
  };

  async componentDidMount() {
    const queryParams = getQueryParams(qs.parse(window.location.search));
    const filial = queryParams.filial || "";
    const date = queryParams.date || getDateFormat(new Date());
    const dateToday = getDateFormat(new Date());
    let generateVisible = date !== dateToday;

    let searchParams = { date };
    let search = `?date=${date}`;

    if (filial && filial.length) {
      search += `&filial=${filial}`;
      searchParams.filial = filial;
    }

    if (!queryParams.date) {
      this.props.history.push({
        pathname: "/reports/day",
        search: search
      });
    }

    const { data: list, meta } = await API.reports.getOne(searchParams, {
      full: true
    });

    let titleHeader = `${date} - ${TITLE_HEADER}`;

    let sumAll = this.getSumAll(list);

    const { data: filials } = await API.filials.getList({}, { full: true });
    const filialsList = [
      {
        title: "Филиал не выбран",
        clear: true
      }
    ];
    (filials || []).forEach((item, i) => {
      if (i === 0) {
        filialsList.push({
          type: "hr"
        });
      }

      filialsList.push({
        id: item._id,
        title: item.name,
        onSelect: true,
        select: true
      });
    });

    this.setState(prevState => {
      return {
        titleHeader,
        loading: false,
        reports: {
          list,
          meta: { ...meta, date }
        },
        filials: {
          list: filialsList
        },
        sumAll,
        form: {
          ...prevState.form,
          date: {
            ...prevState.form.date,
            value: date
          }
        },
        buttons: {
          ...prevState.buttons,
          generateVisible
        }
      };
    });
  }

  getSumAll = list => {
    let sumAll = {
      cashDeskStart: 0,
      sumGive: 0,
      sumPercent: 0,
      sumFine: 0,
      sumIncome: 0,
      sumReturn: 0,
      sumIncomeWithReturn: 0,
      sumAdd: 0,
      sumRemove: 0,
      sumClose: 0,
      cashDesk: 0
    };

    if (list && Array.isArray(list) && list.length) {
      for (let reportDay of list) {
        // На начало дня
        sumAll.cashDeskStart += reportDay.cash_desk_start_day_all;
        // Выдано
        sumAll.sumGive += reportDay.sum_give_all;
        // Полученные проценты
        sumAll.sumPercent += reportDay.sum_percent_all;
        // Полученные штрафы
        sumAll.sumFine += reportDay.sum_fine_all;
        // Получено итого (проценты + штрафы)
        sumAll.sumIncome += reportDay.sum_income_all;
        // Возвраты
        sumAll.sumReturn += reportDay.sum_return_all;
        // Получено всего (проценты + штрафы + возвраты)
        sumAll.sumIncomeWithReturn += reportDay.sum_income_with_return_all;
        // Пополнения
        sumAll.sumAdd += reportDay.sum_add_all;
        // Расходы
        sumAll.sumRemove += reportDay.sum_remove_all;
        // Списания
        sumAll.sumClose += reportDay.sum_remove_to_sale_all;
        // На конец дня
        sumAll.cashDesk += reportDay.cash_desk_all;
      }
    }

    return sumAll;
  };

  handleInput = e => {
    let value = e.target.value;
    let name = e.target.name;
    const { form } = this.state;

    if (name && form[name]) {
      if (form[name].isNumber) {
        value = String(value) || "";
      } else if (form[name].isDate) {
        value = getDateFormat(value);
      }

      this.setState(prevState => {
        return {
          form: {
            ...prevState.form,
            [name]: {
              ...prevState.form[name],
              value,
              isEdited: true,
              isError: false,
              errors: []
            }
          }
        };
      });
    }
  };

  handleDatepicker = (name, value) => {
    this.setState(
      prevState => {
        return {
          form: {
            ...prevState.form,
            [name]: {
              ...prevState.form[name],
              value,
              isEdited: true,
              isError: false,
              errors: []
            }
          }
        };
      },
      async () => {
        await this.handleSearchSubmit();
      }
    );
  };

  handleSelectDropdown(item, name) {
    if (item && name) {
      let value = item.id;

      this.setState(
        prevState => {
          return {
            form: {
              ...prevState.form,
              [name]: {
                ...prevState.form[name],
                value,
                isEdited: true,
                isError: false,
                errors: []
              }
            }
          };
        },
        async () => {
          await this.handleSearchSubmit();
        }
      );
    }
  }

  handleCreateForDate = async e => {
    e.preventDefault();

    const result = validateForm(this.state.form);

    this.setState(prevState => {
      return {
        form: result.form,
        buttons: {
          ...prevState.buttons,
          filtersDisabled: true,
          generateDisabled: true
        }
      };
    });

    // Success
    if (result.valid) {
      const date = this.state.form.date.value;

      let titleHeader = `${date} - ${TITLE_HEADER}`;

      this.setState({
        loading: true,
        titleHeader
      });

      this.props.history.push({
        pathname: "/reports/day",
        search: `?date=${date}`
      });

      const createdReport = await API.reports.createForDate(date, {
        full: true
      });

      if (createdReport) {
        const { data: list, meta } = await API.reports.getOne(
          { date },
          { full: true }
        );

        Alerts.success("Отчёт успешно создан");

        this.setState(prevState => {
          return {
            reports: {
              list,
              meta: { ...meta, date }
            },
            loading: false,
            buttons: {
              ...prevState.buttons,
              filtersDisabled: false,
              generateDisabled: false
            }
          };
        });
      } else {
        this.setState(prevState => {
          return {
            loading: false,
            buttons: {
              ...prevState.buttons,
              filtersDisabled: false,
              generateDisabled: false
            }
          };
        });

        Alerts.error("Отчёт не сформирован");
      }
    } else {
      this.setState(prevState => {
        return {
          buttons: {
            ...prevState.buttons,
            filtersDisabled: false,
            generateDisabled: false
          }
        };
      });

      // Показываем ошибки
      for (let error of result.errors) {
        Alerts.error(error);
      }
    }
  };

  handleDelete = async e => {
    e.preventDefault();

    const result = validateForm(this.state.form);

    this.setState(prevState => {
      return {
        form: result.form,
        modals: {
          ...prevState.modals,
          deleteReportDay: {
            ...prevState.modals.deleteReportDay,
            yesDisabled: true
          }
        }
      };
    });

    // Success
    if (result.valid) {
      const reportId = this.state.reports.list[0]._id;
      const date = this.state.form.date.value;

      this.setState({
        loading: true
      });

      const deletedReport = await API.reports.deleteOneById(reportId, {
        full: true
      });

      if (deletedReport) {
        Alerts.success("Отчёт успешно удалён");

        const { data: list, meta } = await API.reports.getOne(
          { date },
          { full: true }
        );

        this.setState(prevState => {
          return {
            reports: {
              list,
              meta: { ...meta, date }
            },
            loading: false,
            modals: {
              ...prevState.modals,
              deleteReportDay: {
                ...prevState.modals.deleteReportDay,
                isShow: false,
                selectedItemId: null,
                yesDisabled: false
              }
            }
          };
        });
      } else {
        this.setState(prevState => {
          return {
            loading: false,
            modals: {
              ...prevState.modals,
              deleteReportDay: {
                ...prevState.modals.deleteReportDay,
                isShow: false,
                selectedItemId: null,
                yesDisabled: false
              }
            }
          };
        });

        Alerts.error("Отчёт не удалён");
      }
    } else {
      this.setState(prevState => {
        return {
          modals: {
            ...prevState.modals,
            deleteReportDay: {
              ...prevState.modals.deleteReportDay,
              isShow: false,
              selectedItemId: null,
              yesDisabled: false
            }
          }
        };
      });
    }
  };

  handleSearchSubmit = async () => {
    const result = validateForm(this.state.form);

    this.setState({
      form: result.form
    });

    // Success
    if (result.valid) {
      this.setState(prevState => {
        return {
          loading: true,
          reports: {
            list: [],
            meta: { saved: false }
          },
          historyList: [],
          sumAll: this.getSumAll([]),
          footers: {
            day: []
          },
          buttons: {
            ...prevState.buttons,
            filtersDisabled: true
          }
        };
      });

      const filial = this.state.form.filial.value;
      const date = this.state.form.date.value;
      const dateToday = getDateFormat(new Date());
      let generateVisible = date !== dateToday;

      let searchParams = { date };
      let search = `?date=${date}`;

      if (filial && filial.length) {
        search += `&filial=${filial}`;
        searchParams.filial = filial;
      }

      const { data: list, meta } = await API.reports.getOne(searchParams, {
        full: true
      });

      let titleHeader = `${date} - ${TITLE_HEADER}`;
      let sumAll = this.getSumAll(list);

      this.setState(
        prevState => {
          return {
            loading: false,
            titleHeader,
            search: true,
            reports: {
              list,
              meta: { ...meta, date }
            },
            sumAll,
            buttons: {
              ...prevState.buttons,
              filtersDisabled: false,
              generateVisible
            }
          };
        },
        () => {
          this.props.history.push({
            pathname: "/reports/day",
            search
          });
        }
      );
    }
  };

  handleSearchCancel = async e => {
    e.preventDefault();

    this.setState(prevState => {
      return {
        loading: true,
        buttons: {
          ...prevState.buttons,
          filtersDisabled: true,
          generateVisible: false
        }
      };
    });

    const date = getDateFormat(new Date());

    this.props.history.push({
      pathname: "/reports/day",
      search: `?date=${date}`
    });

    const { data: list, meta } = await API.reports.getOne(
      { date },
      { full: true }
    );

    let titleHeader = `${date} - ${TITLE_HEADER}`;
    let sumAll = this.getSumAll(list);

    this.setState(prevState => {
      return {
        loading: false,
        titleHeader,
        search: false,
        reports: {
          list,
          meta: { ...meta, date }
        },
        sumAll,
        form: {
          ...prevState.form,
          date: {
            ...prevState.form.date,
            value: date,
            isEdited: true,
            isError: false,
            errors: []
          },
          filial: {
            ...prevState.form.filial,
            value: "",
            isEdited: true,
            isError: false,
            errors: []
          }
        },
        buttons: {
          ...prevState.buttons,
          filtersDisabled: false
        }
      };
    });
  };

  handleModalOpen = () => {
    this.setState(prevState => {
      return {
        modals: {
          ...prevState.modals,
          deleteReportDay: {
            ...prevState.modals.deleteReportDay,
            isShow: true,
            selectedItemId: this.state.reports.list[0]._id
          }
        }
      };
    });
  };

  handleModalClose = () => {
    this.setState(prevState => {
      return {
        modals: {
          ...prevState.modals,
          deleteReportDay: {
            ...prevState.modals.deleteReportDay,
            isShow: false,
            selectedItemId: null
          }
        }
      };
    });
  };

  getWarningSection = () => {
    if (!this.state.loading) {
      const dateToday = moment(getDateFormat(new Date()), "DD.MM.YYYY");
      const date = moment(this.state.reports.meta.date, "DD.MM.YYYY");

      if (this.state.reports.list.length) {
        if (!this.state.reports.meta.saved) {
          if (dateToday.isSame(date)) {
            return (
              <Section theme="info" className="reports-info">
                Отчёт за сегодня ещё не был сформирован. Информация на данной
                странице может измениться.
              </Section>
            );
          } else {
            return (
              <Section theme="error" className="reports-error">
                На указанную дату, сформированного отчёта не найдено. Информация
                была сформирована на основе Истории, без суммы в кассах.
              </Section>
            );
          }
        }
      } else {
        // Сегодня?
        if (dateToday.isSame(date)) {
          return (
            <Section theme="info" className="reports-info">
              За сегодня ещё не было операций, поэтому здесь пусто.
            </Section>
          );
          // Сегодня позже чем в отчёте?
        } else if (dateToday.isAfter(date)) {
          return (
            <Section theme="error" className="reports-error">
              На указанную дату, сформированного отчёта не найдено. Также не
              найдено Истории операций.
            </Section>
          );
          // Сегодня раньше чем в отчёте?
        } else if (dateToday.isBefore(date)) {
          return (
            <Section theme="warning" className="reports-warning">
              Была выбрана дата, которая ещё не наступила, поэтому здесь пусто.
            </Section>
          );
        }
      }
    }
  };

  getFilialBody = filial => {
    let tbody = [];

    let filialSums = getFilialSumsHistorys(filial.historys);

    let usersOperations = {
      _id: null,
      fio: ""
    };

    // report[0].filials[0].historys = [{}]
    if (filial.historys && filial.historys.length) {
      // Перебираем каджую историю по филиалу
      filial.historys.forEach((history, index) => {
        const sumGiveOnly = getGiveOnly(history, true);
        const sumGetPercent = getSumPercent(history, true);
        const fines = getFinesToHistory(history);
        // const sumCloseOnly = getCloseOnly(history, true);
        const sumPercentNew = getNewSumPercent(filial.historys, history, true);
        const sumGetAll = getSumAll(history, sumGetPercent, fines.allSum, true);
        const IconStatus = getStatusClassString(history._method, true);

        usersOperations._id = history.user_id._id;
        usersOperations.fio = fioLitleTruncateFromObject(history.user_id);

        let icon = null;

        switch (IconStatus) {
          case "dark":
            icon = <IconAddFilled className="icon-td icon-dark" />;
            break;
          case "warning":
            icon = <IconClockFilled className="icon-td icon-warning-active" />;
            break;
          case "error":
            icon = <IconMinusFilled className="icon-td icon-error" />;
            break;
          case "success":
            icon = (
              <IconRefreshFilled className="icon-td icon-success-active" />
            );
            break;
          default:
            break;
        }

        tbody.push(
          <tr
            className={`${IconStatus}-light`}
            key={`report-day-history-${history._id}`}
          >
            <td className="text-center">{index + 1}</td>
            <td className="id">
              <Link to={`/bilets/${history._field._id}`}>
                {history._field.bilet_number}
              </Link>
            </td>
            <td>
              {icon}
              {getStatusString(history._method)}
            </td>
            <td className="text-right">
              {sumGiveOnly !== 0 ? sumFormat(sumGiveOnly) : "-"}
            </td>
            <td className="text-right">
              {sumGetPercent !== 0 ? sumFormat(sumGetPercent) : `-`}
            </td>
            <td className="text-right">
              {fines && fines.list && fines.list.length
                ? fines.list.map(fine => {
                    return (
                      <div key={`report-day-history-fine-${fine._id}`}>
                        {sumFormat(fine.sum)}
                      </div>
                    );
                  })
                : "-"}
            </td>
            <td className="text-right">
              {sumGetAll !== 0 ? sumFormat(sumGetAll) : `-`}
            </td>
            <td className="text-right">
              {sumPercentNew !== 0 ? sumFormat(sumPercentNew) : "-"}
            </td>
            <td>{getDateFormat(history._field.date_return)}</td>
            <td>{getTimeFormat(history.created_at)}</td>
            <td className="icon">
              <Link
                to={`/bilets/${history._field._id}/edit/history/${history._id}`}
              >
                <IconEdit />
              </Link>
            </td>
          </tr>
        );
      });

      let filialSumsCorrect = {
        sum_give: filialSums.sum_give === filial.sum_give,
        sum_percent: filialSums.sum_percent === filial.sum_percent,
        sum_fine: filialSums.sum_fine === filial.sum_fine,
        sum_income_with_return:
          filialSums.sum_income_with_return === filial.sum_income_with_return
      };

      tbody.push(
        <tr
          key={`report-day-filial-end-line-1-${filial.filial_id._id ||
            uuidv4()}`}
          className="header border-top"
        >
          <td className="text-center"></td>
          <td colSpan={2}>Итого</td>
          <td
            className={`${
              !filialSumsCorrect.sum_give ? "error" : ""
            } text-right`}
          >
            {!filialSumsCorrect.sum_give ? (
              <VirtualDiv>
                <P slim={true} size="x-small">
                  В отчёте сохранено
                </P>
                {sumFormat(filial.sum_give)}
                <P slim={true} size="x-small">
                  А должно быть
                </P>
              </VirtualDiv>
            ) : null}
            {sumFormat(filialSums.sum_give)}
            {/* <P size="x-small" slim={true}>
              Выдано
            </P> */}
          </td>
          <td
            className={`${
              !filialSumsCorrect.sum_percent ? "error" : ""
            } text-right`}
          >
            {!filialSumsCorrect.sum_percent ? (
              <VirtualDiv>
                <P slim={true} size="x-small">
                  В отчёте сохранено
                </P>
                {sumFormat(filial.sum_percent)}
                <P slim={true} size="x-small">
                  А должно быть
                </P>
              </VirtualDiv>
            ) : null}
            {sumFormat(filialSums.sum_percent)}
            {/* <P size="x-small" slim={true}>
              Проценты
            </P> */}
          </td>
          <td
            className={`${
              !filialSumsCorrect.sum_fine ? "error" : ""
            } text-right`}
          >
            {!filialSumsCorrect.sum_fine ? (
              <VirtualDiv>
                <P slim={true} size="x-small">
                  В отчёте сохранено
                </P>
                {sumFormat(filial.sum_fine)}
                <P slim={true} size="x-small">
                  А должно быть
                </P>
              </VirtualDiv>
            ) : null}
            {sumFormat(filialSums.sum_fine)}

            {/* <P size="x-small" slim={true}>
              Штрафы
            </P> */}
          </td>
          <td
            className={`${
              !filialSumsCorrect.sum_income_with_return ? "error" : ""
            } text-right`}
          >
            {!filialSumsCorrect.sum_income_with_return ? (
              <VirtualDiv>
                <P slim={true} size="x-small">
                  В отчёте сохранено
                </P>
                {sumFormat(filial.sum_income_with_return)}
                <P slim={true} size="x-small">
                  А должно быть
                </P>
              </VirtualDiv>
            ) : null}
            {sumFormat(filialSums.sum_income_with_return)}
            {/* <P size="x-small" slim={true}>
              Получено
            </P> */}
          </td>
          <td />
          <td colSpan={3}></td>
        </tr>
      );
    } else {
      tbody.push(
        <tr key={uuidv4()}>
          <td colSpan={this.getTableColumns().length} className="text-center">
            <P mutted={true} size="small">
              Пусто
            </P>
          </td>
        </tr>
      );
    }

    return tbody;
  };

  renderHistoryTables = () => {
    let { list } = this.state.reports;

    if (list && list.length) {
      let tables = [];

      // reports = [{}]
      list.forEach(reportDay => {
        // report[0].filials = [{}]
        reportDay.filials.forEach((filial, index) => {
          let usersOperations = {
            _id: null,
            fio: ""
          };

          if (
            filial &&
            filial.historys &&
            filial.historys.length &&
            filial.historys[0] &&
            filial.historys[0].user_id &&
            filial.historys[0].user_id._id
          ) {
            usersOperations._id = filial.historys[0].user_id._id;
            usersOperations.fio = fioLitleTruncateFromObject(
              filial.historys[0].user_id
            );
          }

          // Добавляем таблицу с отчётом по филиалу
          tables.push(
            <div key={uuidv4()}>
              {index !== 0 ? (
                <VirtualDiv>
                  <br />
                  <br />
                </VirtualDiv>
              ) : null}

              <Row align="baseline">
                <Col>
                  <Header size={5} margin="no-bottom">
                    {filial.filial_id.name}
                  </Header>
                </Col>
                <Col text="right">
                  <Link to={`/filials/${filial.filial_id._id}`}>
                    Перейти к филиалу
                  </Link>
                </Col>
              </Row>

              <Table
                columns={this.getTableColumns()}
                loading={this.state.loading}
                tbody={this.getFilialBody(filial)}
              />

              <DaySumsAllFilialTable
                loading={this.state.loading}
                saved={this.state.reports.meta.saved}
                filial={filial}
                user={usersOperations}
              />
            </div>
          );
        });
      });

      return tables;
    }

    return null;
  };

  getTableColumns = () => {
    return [
      { title: "", className: "id" },
      { title: "№", suffix: "з/б", className: "id" },
      { title: "Вид", suffix: "операции" },
      // {title: 'Филиал'},
      // {title: 'Сумма', text: 'right', prefix: 'выдачи', suffix: 'по з/б'},
      { title: "Сумма", text: "right", prefix: "выданная" },
      { title: "Проценты", text: "right", prefix: "полученные" },
      { title: "Штрафы", text: "right", prefix: "полученные" },
      { title: "Итого", text: "right", prefix: "получено" },
      // {title: 'Сумма', text: 'right', prefix: 'списанная', suffix: 'сегодня'},
      { title: "Проценты", text: "right", prefix: "новые" },
      // {title: 'Сумма', text: 'right', prefix: 'возврата', suffix: 'по з/б'},
      { title: "Дата", suffix: "возврата" },
      { title: "Время", suffix: "операции" },
      { title: "", className: "icon" }
    ];
  };

  render() {
    return (
      <div className="short">
        <Helmet>
          <title>{this.state.titleHeader}</title>
        </Helmet>

        <HeaderPage title={TITLE_HEADER}>
          {this.state.historyList &&
          this.state.historyList.length &&
          !this.state.reports.meta.saved ? (
            this.state.buttons.generateVisible ? (
              <Button
                type="button"
                theme="success"
                disabled={this.state.buttons.generateDisabled}
                onClick={this.handleCreateForDate}
              >
                Сформировать отчёт
              </Button>
            ) : null
          ) : this.state.reports.list &&
            this.state.reports.list.length === 1 &&
            this.state.reports.list[0]._id ? (
            <ButtonGroup>
              <Button
                theme="default"
                type="as"
                as={Link}
                to={`/reports/day/${this.state.reports.list[0]._id}/edit`}
              >
                Изменить отчёт
              </Button>
              <Button
                type="button"
                theme="error"
                onClick={() => this.handleModalOpen()}
              >
                Удалить отчёт
              </Button>
            </ButtonGroup>
          ) : null}
        </HeaderPage>

        <Row>
          <Col padding="no-top-bottom">
            <Input
              label="Дата:"
              placeholder="Выберите дату отчёта"
              name="date"
              type="date"
              // dateRight={true}
              size="s"
              value={this.state.form.date.value}
              errors={this.state.form.date.errors}
              handleChange={this.handleInput}
              handleChangeDate={this.handleDatepicker}
            />
          </Col>
          <Col padding="no-top-bottom-left">
            <Dropdown
              label="Филиал:"
              name="filial"
              block={true}
              required={false}
              size="s"
              type="select"
              title="Выберите филиал"
              errors={this.state.form.filial.errors}
              list={this.state.filials.list}
              selectedId={this.state.form.filial.value}
              onSelect={item => {
                this.handleSelectDropdown(item, "filial");
              }}
            />
          </Col>
          <Col padding="no-top-bottom-left"></Col>
        </Row>

        {this.state.reports.list.length ? (
          <div>
            {this.getWarningSection()}

            <DaySumsAll
              loading={this.state.loading}
              saved={this.state.reports.meta.saved}
              sumAll={this.state.sumAll}
            />

            <Row>
              <Col padding="no-top-bottom">
                <Header size={3} margin="no-bottom">
                  По филиалам
                </Header>
              </Col>
            </Row>

            {this.renderHistoryTables()}

            {this.state.reports.meta.saved ? (
              <Modal
                title={this.state.modals.deleteReportDay.title}
                show={this.state.modals.deleteReportDay.isShow}
                yesTitle={this.state.modals.deleteReportDay.yesTitle}
                yesHandlerOnClick={this.handleDelete}
                yesThemeButton={this.state.modals.deleteReportDay.yesClassName}
                yesDisabled={this.state.modals.deleteReportDay.yesDisabled}
                noHandlerOnClick={this.handleModalClose}
              >
                <P>Вы действительно хотите удалить отчёт за день?</P>
              </Modal>
            ) : null}
          </div>
        ) : null}

        <br />
        <br />
      </div>
    );
  }
}

const mapStateToProps = state => ({});

export default withAuth(connect(mapStateToProps)(ReportDayPage));
